// AUTO-GENERATED GraphQL Builder for BookingPartnerChange
import * as Builders from '../';
export class BookingPartnerChangeBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  bookingId(){ return this.add('bookingId'); }
  bookingPackageId(){ return this.add('bookingPackageId'); }
  changeType(){ return this.add('changeType'); }
  status(){ return this.add('status'); }
  fromName(){ return this.add('fromName'); }
  fromVendorId(){ return this.add('fromVendorId'); }
  toName(){ return this.add('toName'); }
  toVendorId(){ return this.add('toVendorId'); }
  amount(){ return this.add('amount'); }
  newAmount(){ return this.add('newAmount'); }
  listPrice(){ return this.add('listPrice'); }
  changedDate(){ return this.add('changedDate'); }
  serviceName(){ return this.add('serviceName'); }
  consent(){ return this.add('consent'); }
  creditAmount(){ return this.add('creditAmount'); }
  toOfferingId(){ return this.add('toOfferingId'); }
  isInhouse(){ return this.add('isInhouse'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  booking(b?:(q:Builders.BookingBuilder)=>void){
    if(this.depth>=5||this.v.has('booking'))return this;
    this.v.add('booking');
    const n=new Builders.BookingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`booking { ${inner} }`);
    return this;
  }

  bookingPackage(b?:(q:Builders.BookingPackageBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingPackage'))return this;
    this.v.add('bookingPackage');
    const n=new Builders.BookingPackageBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPackage { ${inner} }`);
    return this;
  }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  fromVendor(b?:(q:Builders.VendorBuilder)=>void){
    if(this.depth>=5||this.v.has('fromVendor'))return this;
    this.v.add('fromVendor');
    const n=new Builders.VendorBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`fromVendor { ${inner} }`);
    return this;
  }

  toOffering(b?:(q:Builders.OfferingBuilder)=>void){
    if(this.depth>=5||this.v.has('toOffering'))return this;
    this.v.add('toOffering');
    const n=new Builders.OfferingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`toOffering { ${inner} }`);
    return this;
  }

  toVendor(b?:(q:Builders.VendorBuilder)=>void){
    if(this.depth>=5||this.v.has('toVendor'))return this;
    this.v.add('toVendor');
    const n=new Builders.VendorBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`toVendor { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }
}
